
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Root from './routes/root';
import { ToastProvider } from '@heroui/react';

const App = () => (
  <I18nextProvider i18n={i18n}>
    <div className="App">
      <ToastProvider placement="bottom-right" />
      <Root />
    </div>
  </I18nextProvider>
);

export default App;